import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, ShieldCheck, ArrowUpRight, FileCheck2 } from "lucide-react";
import { toast } from "sonner";
import { couponStore, createCheckout, saveLastSession } from "@/lib/api";

const SECTIONS = [
  { title: "DATI MOTORE & ALLESTIMENTO", text: "Cilindrata: 1.968 cc | Potenza: 115 CV | Classe: Euro 6" },
  { title: "STORICO CHILOMETRICO & REVISIONI", text: "Trend chilometri con grafiche certificate e controllo manomissioni." },
  { title: "STATO RCA & ASSICURAZIONE", text: "Verifica copertura attiva, compagnia e scadenze polizza." },
];

export default function Paywall({ targa, unlocked }) {
  const navigate = useNavigate();

  const pay = async () => {
    try {
      const { checkout_url, session_id, coupon_applied } = await createCheckout(targa);
      if (couponStore.get() && !coupon_applied) {
        toast.warning("Coupon non valido o scaduto: prosegui al prezzo pieno.");
      }
      saveLastSession(session_id, targa);
      window.location.href = checkout_url;
    } catch {
      toast.error("Impossibile avviare il pagamento. Riprova.");
    }
  };

  return (
    <div
      className="relative mt-6 rounded-2xl overflow-hidden border border-[#ff007f]/30 bg-[#0c0c10]"
      data-testid="paywall-section"
    >
      <div className="blur-[6px] opacity-40 pointer-events-none select-none p-6 space-y-4" aria-hidden="true">
        {SECTIONS.map((s) => (
          <div key={s.title}>
            <h3 className="font-orbitron text-[13px] text-white tracking-wider">{s.title}</h3>
            <p className="text-xs text-[#8a8a9e] mt-1">{s.text}</p>
          </div>
        ))}
      </div>

      {unlocked ? (
        <div
          className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center gap-3 bg-[#050507]/90 p-6"
          data-testid="paywall-lock-overlay"
        >
          <FileCheck2 size={34} className="text-[#00ff88]" />
          <p className="font-orbitron text-sm tracking-widest">REPORT SBLOCCATO PER QUESTA TARGA</p>
          <button
            data-testid="open-report-button"
            onClick={() => navigate(`/report/${targa}`)}
            className="bg-[#00f0ff] hover:bg-[#00c8d8] text-black py-3 px-6 rounded-xl font-orbitron font-bold text-xs tracking-[0.15em] uppercase shadow-[0_0_20px_rgba(0,240,255,0.4)] hover:-translate-y-0.5 transition-all flex items-center gap-2 cursor-pointer"
          >
            APRI REPORT COMPLETO <ArrowUpRight size={15} />
          </button>
        </div>
      ) : (
        <div
          className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center gap-3 bg-[#050507]/85 backdrop-blur-sm p-6"
          data-testid="paywall-lock-overlay"
        >
          <motion.div
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.25, type: "spring", stiffness: 220, damping: 16 }}
            className="w-14 h-14 rounded-full bg-[#ff007f]/15 border border-[#ff007f] flex items-center justify-center shadow-[0_0_22px_rgba(255,0,127,0.5)]"
          >
            <Lock size={22} className="text-[#ff007f]" />
          </motion.div>
          <h3 className="font-orbitron text-base tracking-widest">SBLOCCA IL REPORT COMPLETO</h3>
          <p className="text-[13px] text-[#8a8a9e] max-w-[320px]">
            Accedi a tutti i dati tecnici, storico revisioni e chilometri certificati.
          </p>
          <div data-testid="paywall-price" className="font-orbitron text-xl font-black text-[#ff007f]">
            35,00 €
          </div>
          <button
            data-testid="stripe-checkout-unlock-button"
            onClick={pay}
            className="w-full max-w-[300px] bg-[#ff007f] hover:bg-[#e00070] text-white py-3.5 rounded-xl font-orbitron font-bold text-xs tracking-[0.15em] uppercase shadow-[0_0_20px_rgba(255,0,127,0.4)] hover:shadow-[0_0_34px_rgba(255,0,127,0.65)] hover:-translate-y-0.5 transition-all flex items-center justify-center gap-2 cursor-pointer"
          >
            Sblocca ora con Stripe <ArrowUpRight size={15} />
          </button>
          <p className="flex items-center gap-1.5 font-jetmono text-[9px] tracking-[0.2em] text-[#8a8a9e]">
            <ShieldCheck size={12} className="text-[#00ff88]" /> PAGAMENTO SICURO · CARTA DI CREDITO
          </p>
        </div>
      )}
    </div>
  );
}
